/* unplugin-vue-components disabled */import { render } from "./SystemInfo.vue?vue&type=template&id=23f278e2&ts=true"
import script from "./SystemInfo.vue?vue&type=script&lang=ts"
export * from "./SystemInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__